import React from 'react';
import PropTypes from 'prop-types';
import {Input, Form} from 'antd';
import TreeView from 'components/common/TreeView';

@autobind
/**
 *
 * @class ListWrapper
 * @extends PureComponen
 */
export default class ExtraColumns extends React.PureComponent {
    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]),
        required: PropTypes.bool,
        meta: PropTypes.object,
        validateStatus: PropTypes.oneOf([
            'success', 'warning', 'error', 'validating',
        ]),
        defaultValue: PropTypes.array,
        size: PropTypes.string,
        disabled: PropTypes.bool,
        addonBefore: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]),
        addonAfter: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]),
        onPressEnter: PropTypes.func,
        autosize: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({
                minRows: PropTypes.number,
                maxRows: PropTypes.number,
            }),
        ]),
        input: PropTypes.shape({
                name: PropTypes.string,
                value: PropTypes.oneOfType([ PropTypes.string, PropTypes.arrayOf(
                    PropTypes.string
                )])}),
        rest: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array,
        ]),
        reportType: PropTypes.string,
    };

    static defaultProps = {
        label: undefined,
        validateStatus: undefined,
        required: false,
        input: {},
        disabled: false,
        reportType: undefined,
    };

    /**
     *
     * @param {Object} props
     */
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selected: props.selected,
            dailyRules : [
                {
                    title: 'سمت',
                    id: 'position_name'
                },
                {
                    title: 'نام و نام خانوادگی',
                    id: 'user_name'
                },
                {
                    title: 'شماره پرسنلی',
                    id: 'personnel_id'
                },
                {
                    title: 'نوع قرارداد',
                    id: 'recruitment_type'
                },
                {
                    title: 'ساعت کاری',
                    id: 'working_hours_names'
                },
                {
                    title: 'تاریخ',
                    id: 'date'
                },
                {
                    title: 'روز هفته',
                    id: 'day'
                },
                {
                    title: 'ورود اول',
                    id: 'clock_in_1'
                },
                {
                    title: 'خروج اول',
                    id: 'clock_out_1'
                },
                {
                    title: 'ورود دوم',
                    id: 'clock_in_2'
                },
                {
                    title: 'خروج دوم',
                    id: 'clock_out_2'
                },
                {
                    title: 'ورود سوم',
                    id: 'clock_in_3'
                },
                {
                    title: 'خروج سوم',
                    id: 'clock_out_3'
                },
                {
                    title: 'وضعیت',
                    id: 'status'
                }
                ],
            allRules: [
                {
                    title: 'سمت',
                    id: 'position_name'
                },
                {
                    title: 'نام و نام خانوادگی',
                    id: 'user_name'
                },
                {
                    title: 'شماره پرسنلی',
                    id: 'personnel_id'
                },
                {
                    title: 'وضعیت',
                    id: 'status'
                }
            ]
        };
    }


    /**
     *
     */
    componentWillMount() {
        super.componentWillMount();

        const {input, defaultValue} = this.props;

        input.onChange(defaultValue);
    }

    /**
     *
     * @return {String}
     * @private
     */
    _validateStatus() {
        const {disabled, required, validateStatus, input, meta} = this.props;
        let _status = validateStatus;

        if (!disabled) {
            if (meta.asyncValidating) {
                _status = 'validating';
            } else if (meta.touched) {
                if (meta.error) {
                    _status = 'error';
                } else {
                    if (!required && app._.isEmpty(input.value)) {
                        _status = 'warning';
                    } else if (meta.valid) {
                        _status = 'success';
                    }
                }
            }
        }
        return _status;
    }

    /**
     *
     */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if( prevProps.reportType  && this.props.reportType  && prevProps.reportType !== this.props.reportType){
            this.props.input.onChange([]);
            this.props.input.onChange(this.props.selectedHeaders || []);
        }
    }

    /**
     *
     * @return {XML}
     */
    render() {
        const {checkAll} = this.props;
        const {
            input,label, required,meta, reportType, ...rest
        } = this.props;

        let {allRules, dailyRules} = this.state;
        return (
            <Form.Item
                help={meta.touched && meta.error}
                validateStatus={this._validateStatus()}
                hasFeedback
                required={required}
            >
                <TreeView
                    checkable
                    nodeKey={'id'}
                    onCheck={(e)=>{
                        input.onChange(e)
                    }}
                    title={ app.translate('routes.home.attendance.reports.Report columns')}
                    showSearch={false}
                    defaultCheckedKeys={input.value ? Array.isArray(input.value) && input.value.length> 0 ? input.value :  Array.isArray(meta.initial) ? meta.initial : [] : []}
                    treeData={reportType === 'total'? allRules : dailyRules}
                    checkAllButton={checkAll}
                    treeStyle={{height: 'calc(100% - 44px)'}}
                />
            </Form.Item>
        );
    }
}
